module.exports = __webpack_public_path__ + "img/1f451.652ec4b.svg";